import { useState, useEffect } from 'react'
import { BASE_API_URL } from 'constants/env'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { StripePaymentMethod } from 'interfaces/stripe-payment-method'
import { API_METHODS } from 'constants/api-methods'
import { handleErrors } from 'utils/handle-errors'
import { useQuery } from 'react-query'
import { organizationsKeys } from 'utils/query-keys'
interface CustomerPaymentMethods {
  customer: {
    id: string
    payment_methods: StripePaymentMethod[]
  }
}
interface UsePaymentMethodProps {
  organizationId?: string
  enabled?: boolean
  paymentMethodType?: string
}

export const usePaymentMethods = ({
  organizationId,
  paymentMethodType = 'card',
}: UsePaymentMethodProps) => {
  const fetchAgencyPaymentMethods = async (): Promise<
    StripePaymentMethod[]
  > => {
    let response = await fetch(
      `${BASE_API_URL}/admin/api/v2/organizations/${organizationId}/customer?payment_method=${encodeURIComponent(
        paymentMethodType
      )}`,
      {
        method: API_METHODS.GET,
        headers: apiHeaders(store.getState()),
      }
    )
    response = handleErrors(response)
    const json: CustomerPaymentMethods = await response.json()
    return json.customer.payment_methods
  }

  return useQuery(
    organizationsKeys.stripePaymentMethods.detail(organizationId || ''),
    () => fetchAgencyPaymentMethods(),
    {
      enabled: !!organizationId,
    }
  )
}
